module.exports = __webpack_public_path__ + "static/media/edb.3c230c42.png";